import { useEffect } from 'react';

import ky, { type Options } from 'ky';
import { useLoginStatus } from './useLoginStatus';
import { useZustandStore } from '../../StoresProvider';
import { useAuthStore } from '../../../components/Login/useAuthStore';
import { apiEndpoints } from '../../../lib/apiEndpoints/apiEndpoints';

export const usePortalGuard = () => {
  const apiBaseURL = apiEndpoints.getAPIEndpoint('root');

  const loginStatus = useLoginStatus();
  const logout = useAuthStore((state) => state.logout);
  const tenantId = useZustandStore('auth', (v) => v.tenantId);

  useEffect(() => {
    const checkPortalEnabled = async () => {
      try {
        const kyOpts: Options = {
          ...(tenantId ? { headers: { 'OT-Customer-Id': tenantId } } : {}),
        };
        const { portalEnabled } = await ky
          .get(`${apiBaseURL}/login/settings`, kyOpts)
          .json<{ portalEnabled: boolean }>();

        if (!portalEnabled) {
          console.log('Portal is disabled. Logging out user...');
          if (loginStatus === 'loggedIn') {
            logout();
          }
        }
      } catch (error) {
        console.error('Failed to check portalEnabled:', error);
      }
    };

    if (tenantId) {
      checkPortalEnabled().then();
    }
  }, [loginStatus, logout, tenantId, apiBaseURL]);
};
